import { SvgIcon, SxProps, Theme } from "@mui/material"

export const ReadIcon = ({ onClick = () => { }, color = "#5C2DB3", sx = {} }: { onClick?: () => void, color?: string, sx?: SxProps<Theme> }) => {
    return (
        <SvgIcon
            onClick={onClick}
            viewBox="0 0 10 9"  // Adjust viewBox to tightly fit the icon
            sx={{
                width: 14,
                height: 14,
                ...sx
            }}
        >
            <path
                d="M3.87109 4.27425L5.12109 5.52425L9.28776 1.35758M8.87109 4.69092V7.60758C8.87109 7.8286 8.7833 8.04056 8.62702 8.19684C8.47074 8.35312 8.25877 8.44092 8.03776 8.44092H2.20443C1.98341 8.44092 1.77145 8.35312 1.61517 8.19684C1.45889 8.04056 1.37109 7.8286 1.37109 7.60758V1.77425C1.37109 1.55324 1.45889 1.34128 1.61517 1.185C1.77145 1.02872 1.98341 0.940918 2.20443 0.940918H6.78776"
                stroke={color}
                strokeWidth="1.5"  // Increased stroke width for better visibility
                strokeLinecap="round"
                strokeLinejoin="round"
                fill={"none"}
            />
        </SvgIcon>
    )
}